import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Megaphone } from 'lucide-react';
import { Settings } from 'lucide-react';
import { LogOut } from 'lucide-react';
import { RotateCwIcon } from 'lucide-react';

export default function OptionsMenu({ onLogout, onRefresh, onBroadcast }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            onBroadcast?.();
          }}
        >
          <ListItemIcon>
            <Megaphone fontSize="medium" />
          </ListItemIcon>
          <ListItemText primary="Broadcast" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            onRefresh?.();
          }}
        >
          <ListItemIcon>
            <RotateCwIcon fontSize="medium" />
          </ListItemIcon>
          <ListItemText primary="Refresh" />
        </MenuItem>
        
        <MenuItem
          onClick={() => {
            handleClose();
            onLogout?.();
          }}
        >
          <ListItemIcon>
            <LogOut fontSize="medium" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </Menu>
    </>
  );
}
